import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import logo from '../../logo.svg'
import axiosInstance from '../../axiosInstance'
import { isLogedIn } from "../helper";

import React, {Component} from 'react';

class Login extends Component{
    constructor(props){
        super(props);
        this.state = {
            username:"",
            password:"",
            errors:{
                username:false,
                password:false,
                invalid:false,
            },
            error_messages:{
                username_message:'გთხოვთ შეიყვანოთ სახელი',
                password_message:'გთხოვთ შეიყვანოთ პაროლი',
                invalid_message:'მომხმარებლის სახელი ან პაროლი არასწორია'
            }
        }
        if(isLogedIn()){
            this.props.history.push("/");
        }
    }

    onLogin(data){
        localStorage.setItem('token',data.token)
        this.props.history.push("/");
    }

    LoginBtnClicked(){
        if(this.isFormValid()){
            var data = {
                "username":this.state.username,
                "password":this.state.password
            }
            axiosInstance.post("/login",data)
            .then(data =>this.onLogin(data.data))
            .catch(err => {
                if(err.response?.status == 401 || err.response?.status == 422){
                    this.setState({
                        ...this.state, 
                        errors:{
                            ...this.state.errors,
                            invalid:true
                        }
                    })
                }
                if(err.response?.status == 501){
                    this.setState({
                        ...this.state, 
                        errors:{
                            ...this.state.errors,
                            invalid:true
                        },
                        error_messages:{
                           ...this.state.error_messages,
                            invalid_message:err.response.data.message
                        }
                    })
                }
            })
        }
    }

    isFormValid(){
        var username = (this.state.username === '');
        var password = (this.state.password === '');
        if(username || password){
            this.setState({
                errors:{
                    ...this.state.errors,
                    username:username,
                    password:password, 
                },
            })
            return false;
        }
        return true;
    }


    onChange(event){
        this.setState({
            ...this.state,
            [event.target.name]:event.target.value,
            errors:{
                
                ...this.state.errors,
                [event.target.name]:false,
                invalid:false
            }
        })
    }
    render(){
        return (
            <Container className = "h-100">
                <Row className = "h-100 align-items-center justify-content-center">
                    <Col className = "col-xs-12 col-sm-8 col-md-6">
                        <Row className = "justify-content-center">
                            <img id="profile-img" className="img-fluid" src={logo} alt="logo"/> 
                        </Row>
                        <Form>
                                    <Alert variant="danger" show={this.state.errors.invalid} className="alert">
                                        {this.state.error_messages.invalid_message}
                                    </Alert>
                                    <Form.Group controlId="formBasicEmail">
                                        <Form.Control 
                                            type="username" 
                                            name="username" 
                                            placeholder="მომხმარებელი"
                                            isInvalid = {this.state.errors.username}
                                            onChange = {(event)=>this.onChange(event)}
                                            />
                                        <Form.Control.Feedback type="invalid" >
                                            {this.state.error_messages.username_message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group controlId="formBasicPassword">
                                        <Form.Control 
                                            type="password" 
                                            name = "password" 
                                            placeholder="პაროლი" 
                                            isInvalid = {this.state.errors.password}
                                            onChange = {(event)=>this.onChange(event)}
                                            />
                                        <Form.Control.Feedback type="invalid" >
                                        {this.state.error_messages.password_message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Button variant="dark" block="true" onClick= {(event)=>this.LoginBtnClicked(this,event)} >
                                        შესვლა
                                    </Button>
                            </Form>
                    </Col>
                </Row>
            </Container>
        )
    }
}
export default Login